define(function(require, exports, module) {
    'use strict';
    const PopupView = require('modules/popup/popup.view');
    const _ = require('underscore');

    module.exports = PopupView.extend({

        additionalEvents: _.extend(PopupView.prototype.additionalEvents, {
            'tap .fn-accept': 'acceptHandler',
            'tap .fn-accept-close': 'closePopupRedirect'
        }),
        setOptions: function() {
            this.options.data.isModal = true;

            // Buttons for accept/decline popup
            if (!this.options.data.buttons) {
                this.options.data.buttons = [{
                    title: this.translate('playtech.mobile.system.message.decline'),
                    className: 'fn-close fn-popup-decline popup-modal__button_type_decline'
                }, {
                    title: this.translate('playtech.mobile.system.message.accept'),
                    className: 'fn-accept popup-modal__button_type_accept'
                }];
            }

            PopupView.prototype.setOptions.apply(this, arguments);
        },
        acceptHandler: function() {
            if (this.options.onAccept) {
                this.options.onAccept.apply(this, arguments);
            }
            return PopupView.prototype.close.apply(this, arguments);

        }
    });
});
